<script>
import {defineAsyncComponent, h} from "vue";

const modules = import.meta.glob('@/views/**/*.vue')
export default {
	name: "AsyncComponent",
	props: {
		path: {
			type: String,
			default: "",
		},
	},
	setup(props) {
		const viewLoader = modules[`/src/views/${props.path}.vue`]
		if (!viewLoader) {
			console.log(`路径错误,找不到=>/src/views/${props.path}.vue`)
			return
		}
		const AsyncComp = defineAsyncComponent(() => viewLoader());
		// console.log(modules,props.path,modules[`/src/views/${props.path}.vue`])
		return () => h(AsyncComp);
	},
};
</script>

<style>
</style>
